function useQueryKey() {
  const { user } = useAuthorizeStore()
  return [user?.userId, 'product-previews']
}

const path = '/api/product-previews'

export function useProductPreviews() {
  const { loggedIn, headers } = useAuthorizeStore()

  const queryKey = useQueryKey()

  return useQuery({
    queryKey,
    enabled: loggedIn,
    async queryFn() {
      return $fetch<Record<string, string>>(path, {
        headers: await headers(),
      })
    },
  })
}

export function useEnableProductPreview() {
  const { loggedIn, headers } = useAuthorizeStore()

  const queryKey = useQueryKey()

  const queryClient = useQueryClient()

  const toast = useUiToast()

  return useMutation({
    mutationKey: ['enablePreview'],
    async mutationFn(variant: SingleProductVariant) {
      if (!loggedIn) {
        return
      }

      const previews = await $fetch(path, {
        method: 'PUT',
        headers: await headers(),
        body: {
          sku: variant.sku,
          name: variant.title ?? variant.name,
        },
      })

      queryClient.setQueryData(queryKey, previews)
    },
    onSuccess() {
      toast.success({
        message:
          'Ditt vurderingseksemplar er bestilt og aktivert, du finner det på Min side.',
        buttons: [
          {
            text: 'Gå til Min side',
            onClick: () => {
              navigateTo({
                name: 'minside',
                hash: '#vurderingseksemplarer',
              })
            },
          },
        ],
      })
    },
  })
}
